var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"encabezado row-center"},[_c('h1',[_vm._v(_vm._s(_vm.$t(("encabezado." + _vm.data))))]),_vm._v(" "),(_vm.showMigas)?_c('div',{staticClass:"migas-wrapper"},[_c('div',{staticClass:"container"},[_c('migas',{attrs:{"inicioPersonalizado":_vm.inicioPersonalizado,"last":_vm.last}})],1)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20d010ea","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/encabezado.vue
// module id = null
// module chunks = 